export default function recordWithId<T extends { id: string | number }>(
  item: T
): T["id"] {
  return item.id;
}
